module.exports = __webpack_public_path__ + "assets/csv/student_analytics_enabled.csv"